import PropTypes from 'prop-types'

export default function ProjectTypeButton({
  title,
  description,
  onClick,
  children,
}) {
  return (
    <div
      className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-cursor-pointer tw-bg-white tw-py-12 tw-px-10 tw-m-8 tw-rounded-md tw-border tw-border-solid tw-border-white hover:tw-border hover:tw-border-solid hover:tw-border-primary"
      tabIndex="0"
      onClick={onClick}>
      {children}
      <h2 className="tw-text-lg tw-mb-5 tw-mt-10 tw-font-bold tw-px-5 tw-text-system-grey-900 tw-text-center">
        {title}
      </h2>
      <p className="tw-m-0 tw-text-center tw-text-system-grey-500 tw-leading-relaxed tw-text-sm">
        {description}
      </p>
    </div>
  )
}

ProjectTypeButton.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  childen: PropTypes.node,
  children: PropTypes.node,
}
